import { matchPath } from "react-router";

import { linkToLogin } from "routes/login/links";
import { linkToUploadSuccess } from "routes/upload-success/links";

import config from "custom/config";

const VISIBILITY_REGEX = new RegExp(
  "(^/@|^/$|^" +
    config.PAGES.displayFeature.path +
    "/|^" +
    config.PAGES.embeddable.path +
    ")",
  "g"
);

export default function getMapIsVisible(pathname: string) {
  const isOnUploadSuccessPath = matchPath(pathname, {
    path: linkToUploadSuccess(),
    exact: false
  });
  const isOnLogin = matchPath(pathname, {
    path: linkToLogin()
  });

  const matchesVisibilityRegex = pathname.match(VISIBILITY_REGEX);

  return isOnUploadSuccessPath || isOnLogin || matchesVisibilityRegex;
}
